<template>
    <div class="dynamic-landing">
        <div class="dynamic-landing__centered">
            <img src="/img/svg-icons/success.svg" alt="success" />
            <br />
        </div>
        <div class="dynamic-landing__centered">
            <h1>{{ $t('dynamicess.closureTitle2') }}</h1>
        </div>
        <div class="dynamic-landing__centered">
            <h4>{{ $t('dynamicess.controlsTitle') }}</h4>
            <span>
                {{ $t('dynamicess.controlsExplanation') }}
            </span>
            <br />
            <img src="/img/controls-screen.png" alt="controls" />
            <br />
            <br />
            <router-link :to="{ name: 'base.installation.dashboard', params: { id: idSite } }">
                <button class="sg-btn sg-blue">
                    {{ $t('dynamicess.goDashboard') }}
                </button>
            </router-link>
        </div>
    </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component()
export default class Closure extends Vue {
    get idSite() {
        return this.$route.params.id;
    }
}
</script>
